import * as yup from 'yup';

export const US_ZIP_REGEX = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

export const ERROR_MESSAGES = {
  COMMON_REQUIRED: 'This is a required field',
  DATE_RANGE_REQUIRED: 'Both Dates are Required',
  EVENT_NAME_REQUIRED: 'Event Name is Required',
  INVALID_ZIP_CODE: 'Invalid Zip Code',
  PERCENTAGE_REQUIRED: 'Percentage is Required',
  PERCENTAGE_MIN_ZERO: 'Percentage should be greater than Zero',
};

export const SeasonalityEventSchema = yup.object().shape({
  type: yup.string(),
  date: yup
    .array()
    .of(
      yup
        .string()
        .required(ERROR_MESSAGES.DATE_RANGE_REQUIRED)
        .typeError(ERROR_MESSAGES.DATE_RANGE_REQUIRED),
    )
    .required(ERROR_MESSAGES.DATE_RANGE_REQUIRED)
    .min(2, ERROR_MESSAGES.DATE_RANGE_REQUIRED)
    .max(2, ERROR_MESSAGES.DATE_RANGE_REQUIRED)
    .typeError(ERROR_MESSAGES.DATE_RANGE_REQUIRED),
  name: yup
    .string()
    .required(ERROR_MESSAGES.EVENT_NAME_REQUIRED)
    .typeError(ERROR_MESSAGES.EVENT_NAME_REQUIRED),
  percentage: yup
    .number()
    .required(ERROR_MESSAGES.PERCENTAGE_REQUIRED)
    .typeError(ERROR_MESSAGES.PERCENTAGE_REQUIRED)
    .min(1, ERROR_MESSAGES.PERCENTAGE_MIN_ZERO),
});
